import { render, staticRenderFns } from "./FacilityEditFormBasic.vue?vue&type=template&id=70bf4a14&"
import script from "./FacilityEditFormBasic.vue?vue&type=script&lang=js&"
export * from "./FacilityEditFormBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports